<style lang="scss">
.add-visitor-image {
  .visitor-image {
    max-width: 100%;
    max-height: 200px;
    cursor: pointer;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <section class="add-visitor-image" v-if="visitor">
    <b-alert v-if="visitor.created_by_prison" class="p-1 d-flex" show variant="danger">
      <div>
        <alert-triangle-icon />
      </div>
      <span class="ml-1">
        This visitor is an establishment created user - they haven't submitted ID.
      </span>
    </b-alert>
    <div v-else class="row">
      <!-- 3 Id Images -->
      <div :class="getColClass()" class="d-flex justify-content-center" v-if="showProfilePicture">
        <img class="visitor-image" cy="profile" :src="visitor.assets.profile_picture_url"
             @click="expandMedia(visitor.assets.profile_picture_url)">
      </div>
      <div :class="getColClass()" class="d-flex justify-content-center" v-if="showIdentityFront">
        <img class="visitor-image" cy="front" :src="visitor.assets.identity_picture_url"
             @click="expandMedia(visitor.assets.identity_picture_url)">
      </div>
      <div :class="getColClass()" class="d-flex justify-content-center" v-if="showIdentityBack">
        <img class="visitor-image" cy="back" :src="visitor.assets.identity_picture_back_url"
             @click="expandMedia(visitor.assets.identity_picture_back_url)">
      </div>

      <div class="col-12 mt-2">
        <b-btn variant="primary" @click="viewMediaSideBySide()"
               :class="visitor.assets.id_type !== 'Child' ? 'full-width' : ''">
          <span class="fas fa-search"></span> View Side by Side Large
        </b-btn>
      </div>
    </div>

    <b-modal id="modal-expand-media-visitor" hide-footer size="xl">
      <full-screen-image-modal v-if="imageToShow" :image-url="imageToShow"></full-screen-image-modal>
    </b-modal>

    <b-modal id="modal-expand-media-side-visitor" hide-footer size="xl">
      <images-side-by-side-modal :imageUrls="sideImages"></images-side-by-side-modal>
    </b-modal>
  </section>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import FullScreenImageModal from '@/components/modals/FullScreenImageModal.vue';
import ImagesSideBySideModal from '@/components/modals/ImagesSideBySideModal.vue';
import { AlertTriangleIcon } from 'vue-feather-icons'

export default {
  components: {
    FullScreenImageModal,
    ImagesSideBySideModal,
    AlertTriangleIcon
  },
  props: {},
  data() {
    return {
      canRequestId: true,
      imageToShow: '',
      showProfilePicture: false,
      showIdentityFront: false,
      showIdentityBack: false,
      sideImages: [],
    };
  },
  computed: {
    ...mapState({
      visitor: state => state.visitor.visitor,
    }),
  },
  mounted() {
    this.getColClass(); // call once here to set the images to show
  },
  methods: {
    getColClass() { // show columns based on the licence type and age
      if (this.visitor.created_by_prison) {
        return;
      }

      const driving = this.visitor.assets.id_type === 'DrivingLicence';
      const government = this.visitor.assets.id_type === 'GovernmentIssuedId';
      const passport = this.visitor.assets.id_type === 'Passport';
      const child = this.visitor.assets.id_type === 'Child';
      const under18 = this.visitor.under18;

      if (child) {
        this.showMediaType(true, false, false);
        return 'col-12';
      }
      if (driving) {
        this.showMediaType(true, true, false);
        return 'col-6';
      }
      if (government) {
        if (!under18) {
          this.showMediaType(true, true, true);
          return 'col-4';
        } else {
          this.showMediaType(true, true, false);
          return 'col-6';
        }
      }
      if (passport) {
        this.showMediaType(true, true, true);
        return 'col-4';
      }
    },
    showMediaType(profile, front, back) {
      this.showProfilePicture = profile;
      this.showIdentityFront = front;
      this.showIdentityBack = back;
    },
    expandMedia(imageUrl) {
      this.imageToShow = imageUrl;
      this.$bvModal.show('modal-expand-media-visitor');
    },
    viewMediaSideBySide() {
      this.sideImages = []; // reset
      const assets = this.visitor.assets;

      if (this.showProfilePicture) {
        this.sideImages.push(assets.profile_picture_url);
      }

      if(this.showIdentityFront) {
        this.sideImages.push(assets.identity_picture_url);
      }

      if(this.showIdentityBack) {
        this.sideImages.push(assets.identity_picture_back_url);
      }

      this.$bvModal.show('modal-expand-media-side-visitor');
    },
  },
};
</script>
